import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const PageHeaderContext = createContext({
  header: null,
  setPageHeader: () => {},
});

/**
 * Lets an individual page inject content into the shared horizontal topbar
 * (rendered once, in Sidebar.js) instead of rendering its own separate
 * page-level header bar. `header` is `{ left, right }` — either half can be
 * omitted. Pages must clear their header (pass `null`) on unmount.
 */
export const PageHeaderProvider = ({ children }) => {
  const [header, setHeader] = useState(null);
  const setPageHeader = useCallback((next) => setHeader(next), []);
  const value = useMemo(() => ({ header, setPageHeader }), [header, setPageHeader]);

  return (
    <PageHeaderContext.Provider value={value}>
      {children}
    </PageHeaderContext.Provider>
  );
};

export const usePageHeader = () => useContext(PageHeaderContext);
